<template>
  <div class="most-popular__wrapper">
    <p class="most-popular__title subtitle-3">Most Popular</p>
    <ul>
      <li
        v-for="(item, index) in items"
        :key="index"
        class="most-popular__item text-body"
      >
        <a-link :to="getArticleLink(item)" :trailing-slash="!item.IsMigrated">
          {{ item.Topic }}
        </a-link>
        <div v-if="false" class="most-popular__sponsored">Sponsored</div>
      </li>
    </ul>
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import { propValidator, PROP_TYPES } from '@/utils/validators'

export default {
  name: 'MostPopularList',
  mixins: [mixins.urlGenerators],
  props: {
    items: propValidator([PROP_TYPES.ARRAY])
  },
  methods: {
    getArticleLink(item) {
      return this.generateArticlePath({
        slug: item.Slug,
        categorySlug: item.CategorySlug,
        isMigrated: item.IsMigrated
      })
    }
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>

<style lang="scss" scoped>
.most-popular__wrapper {
  border-radius: 4px;
  background: $c--gray-soft;
  padding: 24px 12px;
  margin-top: 32px;
}

.most-popular__title {
  font-weight: 600;
  padding: 0 0 12px 12px;
}

.most-popular__item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &:not(:last-child) {
    border-bottom: 1px solid rgba($c--gray-dark-2, 0.5);
  }

  a {
    width: 100%;
    padding: 18px 12px;
    color: $c--gray-dark-2;

    &:hover {
      color: $c--main;
    }
  }

  &:last-child a {
    padding-bottom: 0;
  }
}

.most-popular__divider {
  height: 1px;
  width: 100%;
  background: rgba($c--gray-dark-2, 0.5);
  margin-top: 24px;
}

.most-popular__sponsored {
  display: flex;
  padding: 4px 10px;
  margin-top: 12px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  border: 1px solid $c--gray-light;
  background: rgba($c--white, 0.5);
  color: $c--gray-2;
  font-size: 14px;
  line-height: 16px;

  @include mobile {
    font-size: 12px;
    line-height: 14px;
  }
}
</style>
